module.exports = __webpack_public_path__ + "img/red-desert-decal-09.c79e40de.png";